/**
 * MCP commerce_media → widget megjelenítés (termék kártya / katalógus).
 */

/**
 * @param {unknown} raw
 * @returns {{ layout: 'product'|'catalog', items: Array<CommerceMediaItem> }|null}
 */

/**
 * @typedef {Object} CommerceMediaItem
 * @property {string|null} name
 * @property {string|null} url
 * @property {string|null} image_url
 * @property {string|null} image_alt
 * @property {string|null} price_label
 * @property {boolean|null} in_stock
 * @property {string|null} stock_label
 */

export function mapCommerceMedia(raw) {
    if (! raw || typeof raw !== 'object' || ! Array.isArray(raw.items) || raw.items.length === 0) {
        return null;
    }

    const layout = raw.layout === 'product' ? 'product' : 'catalog';

    const items = raw.items
        .filter((item) => item && typeof item === 'object')
        .map((item) => ({
            name: typeof item.name === 'string' && item.name !== '' ? item.name : null,
            url: typeof item.url === 'string' && item.url !== '' ? item.url : null,
            image_url: typeof item.image_url === 'string' && item.image_url !== '' ? item.image_url : null,
            image_alt: typeof item.image_alt === 'string' && item.image_alt !== ''
                ? item.image_alt
                : (typeof item.name === 'string' ? item.name : null),
            price_label: typeof item.price_label === 'string' && item.price_label !== '' ? item.price_label : null,
            in_stock: typeof item.in_stock === 'boolean' ? item.in_stock : null,
            stock_label: typeof item.stock_label === 'string' && item.stock_label !== '' ? item.stock_label : null,
        }));

    if (items.length === 0) {
        return null;
    }

    return { layout, items };
}

export function hasCommerceMedia(msg) {
    return (msg?.commerceMedia?.items?.length ?? 0) > 0;
}

export function commerceMediaLinkLabel(item) {
    if (item?.name) {
        return item.name;
    }

    return 'Termék megtekintése';
}
